import { useCallback, useState, useEffect } from 'react';

function useFocusMenu(size) {
  const [currentFocus, setCurrentFocus] = useState(-1);

  const handleKeyDown = useCallback(
    e => {
      if (e.keyCode === 40) {
        e.preventDefault();
        setCurrentFocus(currentFocus === size - 1 ? 0 : currentFocus + 1);
      } else if (e.keyCode === 38) {
        e.preventDefault();
        setCurrentFocus(currentFocus <= 0 ? size - 1 : currentFocus - 1);
      }
    },
    [size, currentFocus, setCurrentFocus]
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return [currentFocus, setCurrentFocus];
}

export default useFocusMenu;
